import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:

import Collapse from 'bootstrap/js/dist/collapse';

import * as cardTeaserSlider from './scripts/card-teaser-slider';
cardTeaserSlider.init();

import * as imgTeaserSlider from './scripts/img-teaser-slider';
imgTeaserSlider.init();

import * as facilitiesSlider from './scripts/facilities-slider';
facilitiesSlider.init();

import * as lightbox from '@elements/lightbox';
lightbox.init();

import * as parallax from "./scripts/parallax";
parallax.init();

import * as facilitiesMap from "./scripts/facilitie-map";
facilitiesMap.init();

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init();

import * as ajaxFormScrollTop from './scripts/ajax-form-scroll-top';
ajaxFormScrollTop.init();


import * as circleAnimation from './scripts/circle-animation';
circleAnimation.init();


